import React, { FC } from 'react';
import Busy from '../../Shared/Busy';

type Props = {
  show: boolean;
};

const BusyContainer: FC<Props> = ({ show }) => {
  return (
    <span
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, 0)',
        display: show ? 'inline-block' : 'none'
      }}
    >
      <Busy />
    </span>
  );
};

export default BusyContainer;
